<template>
    <div class="col-sm-12 like-body" >
          <div class="row main-ct">
            <div class="fixed-ct d-none d-md-block d-lg-block  col-md-4 col-lg-4" >
                <div style="text-align: center;margin-top:80px ;">
                    <div style="width: 50%; margin: 0 auto; text-align: left;" data-aos="fade-up-right"> 
                        <h1>Resume</h1>
                        <ul class="resume-list list-unstyled" >
                            <li style="padding:10px;" class="fixed-education" id="fixed-education">Education</li>
                            <li style="padding:10px;" class="fixed-experience" id="fixed-experience">Experience</li>
                            <li style="padding:10px;" class="fixed-skills" id="fixed-skills">Skills</li>
                            <li style="padding:10px;" class="fixed-conferences" id="fixed-conferences">Conferences</li>
                            <li style="padding:10px;" class="fixed-contributions" id="fixed-contributions">Contributions</li>
                            <li style="padding:10px;" class="fixed-achievements" id="fixed-achievements">Achievements</li>
                            <li style="padding:10px;" class="fixed-organizations" id="fixed-organizations">Organizations</li>
                            
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-sm-6" >
                    <p class="resume-class" id="education" data-aos="fade-left">Education</p>
                    <div class="container" data-aos="zoom-in">
                        <table >
                            <tr>
                                <td>
                                    <img src="../assets/pict_logo.png" style="height:50px;width: 50px; margin-top: 25px; margin-bottom:80px;margin-right:20px;"/>
                                </td>
                                <td>
                                    <p class="edu-duration">2020-2023</p>
                                    <p class="edu-degree">Bachelor of Engineering in Computer Science</p>
                                    <p class="edu-university">Savitribai Phule Pune University</p>
                                    <p class="edu-desc">SCTR'S Pune Institute of Computer Technology, Pune<br>Result: 9.45 CGPA
                                                        </p>
                                </td>
                            </tr>
                        </table>
                        <hr/>
                    </div>
                    <div class="container" data-aos="zoom-in">
                        <table >
                            <tr>
                                <td>
                                    <img src="../assets/mit.png" style="height:50px;width: 50px; margin-top: 25px;margin-bottom:80px;margin-right:20px;"/>
                            
                                </td>
                                <td>
                                    <p class="edu-duration">2017-2020</p>
                                    <p class="edu-degree">Diploma in Computer Engineering </p>
                                    <p class="edu-university">Maharashtra State Board of Technical Education</p>
                                    <p class="edu-desc">MAEER's MIT Polytechnic, Pune<br>Result: 96.40%
                                                        </p>
                                </td>
                            </tr>
                        </table>
                        <hr/>
                    </div>
                    <div class="container" data-aos="zoom-in">
                        <table >
                            <tr>
                                <td>
                                    <img src="http://duplawcollege.ac.in/Images/gf.jpg" style="height:40px;width: 40px; margin-top: 25px;margin-bottom:80px;margin-right:20px;"/>
                                </td>
                                <td>
                                    <p class="edu-duration">2011-2017</p>
                                    <p class="edu-degree">Secondary School Certificate</p>
                                    <p class="edu-university">Central Board of Secondary Education</p>
                                    <p class="edu-desc">Godavari Foundation's DUPEMS, Savda<br>Result: 8.4 CGPA
                                                        </p>
                                </td>
                            </tr>
                        </table>
                        <hr/>
                    </div>

                    <p class="resume-class" id="experience" data-aos="fade-left">Experience</p>
                    <div class="container" v-for="experience in experiences"  data-aos="zoom-in">
                        <table >
                            <tr>
                                <td>
                                    <img :src="experience.icon" style="height:50px;width: 60px; margin-bottom:80px;margin-right:20px;"/>
                            
                                </td>
                                <td>
                                    <p class="edu-duration">{{ experience.duration }}</p>
                                    <p class="edu-degree">{{ experience.designation  }}</p>
                                    <p class="edu-university"> {{ experience.name }}</p>
                                    <p class="edu-desc">{{ experience.description1 }}
                                        <br>
                                        {{ experience.description }}
                                    </p>
                                    <div class="container" style="margin-top: 5px;">
                                        <div class="skill-chip" v-for="skill in experience.skills">
                                            {{ skill}}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                        <hr/>
                    </div>
                      <p class="resume-class" id="skills" data-aos="fade-left">Skills</p>
                    <div class="row" style="display: flex;justify-content: center;"  >
                            <div class="skills-container container col-sm-2" v-for="skill in skills">
                                <div class="skill-card card" data-aos="flip-right">
                                    <center>
                                        <img class="card-img-top" :src="skill.icon" alt={{skill.name}}>
                                        <br>
                                        <span>{{skill.name}}</span>
                                    </center>
                                </div>
                            </div>
                    </div>
                    
                    <p class="resume-class" id="conferences" data-aos="fade-left">Conferences</p>
                    <div class="container">
                        <table  data-aos="zoom-in">
                            <tr>
                                <td>
                                    <img :src="require('../assets/ieee.png')" style="height:50px;width: 50px; margin-bottom:80px;margin-right:20px;"/>
                                </td>
                                <td>
                                    <p class="edu-duration">June 2023</p>
                                    <p class="edu-degree"> The Role of Activation Function in Deep Learning: A Comprehensive and Comparative Review of Properties, Advantages and Challenges</p>
                                    <p class="edu-university">7<sup>th</sup> IEEE International Conference on "Computing, Communication, Control and Automation" (IEEE ICCUBEA-2023)</p>
                                    <p class="edu-desc"><br>
                                        <a target="blank" href="#">View Technical Paper</a>     <br>
                                    </p>
                                  
                                </td>
                            </tr>
                        </table >
                        <hr>
                        <table  data-aos="zoom-in">
                            <tr>
                                <td>
                                    <img :src="require('../assets/ieee.png')" style="height:50px;width: 50px; margin-bottom:80px;margin-right:20px;"/>
                                </td>
                                <td>
                                    <p class="edu-duration">June 2023</p>
                                    <p class="edu-degree"> Smart Self-Checkout System for Supermarkets</p>
                                    <p class="edu-university">3<sup>rd</sup> IEEE International Conference on "Technology, Engineering, Management for Societal impact using Marketing, Entrepreneurship and Talent" (IEEE TEMSMET-2023)</p>
                                    <p class="edu-desc"><br>
                                        <a target="blank" href="https://ieeexplore.ieee.org/document/10150048">View Technical Paper</a>     <br>
                                    </p>
                                  
                                </td>
                            </tr>
                        </table >
                        <hr>
                        <table  data-aos="zoom-in">
                            <tr>
                                <td>
                                    <img :src="require('../assets/ieee.png')" style="height:50px;width: 50px; margin-bottom:80px;margin-right:20px;"/>
                                </td>
                                <td>
                                    <p class="edu-duration">March 2023</p>
                                    <p class="edu-degree"> Real Time Face Recognition Based Attendance System using Multi Task Cascaded Convolutional Neural Network</p>
                                    <p class="edu-university">5<sup>th</sup> IEEE INTERNATIONAL CONFERENCE on “Emerging Smart Computing & Informatics” (IEEE ESCI-2023)</p>
                                    <p class="edu-desc"><br>
                                        <a target="blank" href="https://ieeexplore.ieee.org/document/10099879">View Technical Paper</a>     <br>
                                        <a target="blank" href="https://drive.google.com/file/d/1hkT7d_YPdnh8kRE194dbO1zHC5L8BzDG/view?usp=share_link">Presentor Certificate </a>   <br>
                                    </p>
                                  
                                </td>
                            </tr>
                        </table >
                        <hr>
                        <table data-aos="zoom-in" >
                            <tr>
                                <td>
                                    <img :src="require('../assets/AOTA2023.jpg')" style="height:50px;width: 50px;margin-bottom:80px;margin-right:20px;"/>
                                </td>
                                <td>
                                    <p class="edu-duration">Jan 2023</p>
                                    <p class="edu-degree">Real-Time Attendance System using Machine Learning Algorithms & Bluetooth</p>
                                    <p class="edu-university">INTERNATIONAL CONFERENCE ON ADVANCED OPTIMIZATION TECHNIQUES AND APPLICATIONS (AOTA)</p>
                                    <p class="edu-desc"><br>
                                        <a target="blank" href="#">View Technical Paper</a>     <br>
                                        <a target="blank" href="https://drive.google.com/file/d/1vQeuRLhplzOfF0lmY26nrTXr4GvQRM6O/view?usp=sharing">Presentor Certificate </a>   <br>
                                        <a target="blank" href="https://drive.google.com/file/d/12-eedbKefiJJYxrhwybEYc3qpNpG3q5s/view?usp=sharing">Runner Up Certificate </a> 
                                    </p>
                                  
                                </td>
                            </tr>
                        </table >
                        <hr>
                        <table data-aos="zoom-in">
                            <tr>
                                <td>
                                    <img src="https://ijsrcseit.com/img/logo.png" style="height:50px;width: 50px; margin-bottom:80px;margin-right:20px;"/>
                                </td>
                                <td>
                                    <p class="edu-duration">Nov 2022</p>
                                    <p class="edu-degree">A Survey on Face Recognition Techniques in Machine Learning</p>
                                    <p class="edu-university">International Journal of Scientific Research in Computer Science, Engineering and Information Technology (IJSRCSEIT)</p>
                                    <p class="edu-desc"><br><a target="blank" href="https://ijsrcseit.com/CSEIT228558">View Technical Paper</a> </p>
                                </td>
                            </tr>
                        </table >
                        <hr/>
                      
                    </div>
                    <p class="resume-class" id="contributions" data-aos="fade-left">Contributions (Open Source)</p>
                    <div class="container" v-for="contribution in contributions">
                        <table data-aos="zoom-in">
                            <tr>
                                <td>
                                    <img :src="contribution.icon" style="height:50px; width: 50px; margin-bottom:80px;margin-right:20px; object-fit: contain;"/>
                                </td>
                                <td>
                                    <!-- <p class="edu-duration">{{ contribution. }}</p> -->
                                    <p class="edu-degree">{{ contribution.name }}</p>
                                    <p class="edu-university">{{ contribution.pr_no }}</p>
                                    <p class="edu-desc">Official Site: <a :href="contribution.site_url" target="_blank">Visit</a></p>
                                    <p class="edu-desc">Github: <a :href="contribution.github_url" target="_blank">Visit</a></p>
                                </td>
                            </tr>
                        </table>
                        <hr/>
                    </div>
                   <p class="resume-class" id="achievements" data-aos="fade-left">Achievements</p>
                    <div class="container" v-for="achievement in achievements">
                        <table data-aos="zoom-in">
                            <tr>
                                <td>
                                    <img :src="achievement.icon" style="height:50px; margin-bottom:80px;margin-right:20px;"/>
                                </td>
                                <td>
                                    <p class="edu-duration">{{ achievement.duration }}</p>
                                    <p class="edu-degree">{{ achievement.rank }}</p>
                                    <p class="edu-university">{{ achievement.name }}</p>
                                    <p class="edu-desc">{{ achievement.description }}</p>
                                </td>
                            </tr>
                        </table>
                        <hr/>
                    </div>
                    <p class="resume-class" id="organizations" data-aos="fade-left">Organizations</p>
                    <div class="container" v-for="organization in organizations">
                        <table data-aos="zoom-in">
                            <tr>
                                <td>
                                    <img :src="organization.icon" style="height:30px; margin-top: 10px; margin-bottom:80px;margin-right:20px;"/>
                                </td>
                                <td>
                                    <p class="edu-duration">{{ organization.duration }}</p>
                                    <p class="edu-degree">{{ organization.name }}</p>
                                    <p class="edu-university">{{ organization.designation }}</p>
                                    <p class="edu-desc">{{ organization.description }}</p>
                                </td>
                            </tr>
                        </table>
                        <hr/>
                    </div>
            </div>
        </div>
    
    </div>
  
</template>

<script>

    import $ from "jquery";
    export default {
        name: "ResumeBlock",
        data: function () {
            return {
                conferences:[
                    {
                        icon:"",
                        name:"",
                        publisher:"",
                        duration:"",
                    }
                ],
                experiences:[
                    {
                        name:"Rhythmflows",
                        designation:"Technology Head",
                        duration:"Nov 2023 - Present",
                        description1:"Full Time Employment",
                        description:"Leading end-to-end architecture, design, and delivery for Payment Hub, API Engine, Workflow Engine, and Ticketing Platform.",
                        skills:["Java","SpringBoot","ReactJS", "JavaScript", "Thymeleaf","RESTful architecture","AWS","Hibernate","PostgreSQL","Microservices","Kubernetes","Docker","Postman"],
                        icon:require("../assets/rhythmflows.png")
                    },
                    {
                        name:"Kylas",
                        designation:"Product Engineering Intern",
                        duration:"Jan 2023 - July 2023",
                        description1:"Internship",
                        description:"Developed a web service to manage incidents and maintenance events.\nWeb service includes support for updates via MS Teams webhooks and email subscriptions.",
                        skills:["Java","SpringBoot","Thymeleaf","RESTful architecture","AWS","Hibernate","PostgreSQL","Mockito","JUnit","WireMock","Docker","Postman"],
                        icon:require("../assets/kylas.jpg")
                    },
                    {
                        name:"NICE Systems",
                        designation:"SDE Intern",
                        duration:"Nov 2021 - July 2022",
                        description1:"Internship",
                        description:"Developed a studio environment for creating new NLP models using Vue.js. \nDeveloped APIs in Flask to extract trade insights from communication data using NLP services of AWS.",
                        skills:["AWS","Vue.js","Flask","Python","RESTful API","NLP","Postman"],
                        icon:"https://download.logo.wine/logo/NICE_Ltd./NICE_Ltd.-Logo.wine.png"
                    },
                    {
                        name:"GeeksforGeeks",
                        designation:"Technical Content Writer ",
                        duration:"Jul 2021 - Dec 2021",
                        description1:"Internship",
                        description:"Technical Content Writer at GeeksforGeeks,\nAuthored technical articles on cutting edge technologies",
                        skills:["Node.js", "Java", "JavaScript", "Bootstrap", "JQuery"],
                        icon:"https://img.icons8.com/color/512/GeeksforGeeks.png"
                    },
                    {
                        name:"Freelancer.com",
                        designation:"Full Stack Freelancer",
                        duration:"Apr 2020 - Jan 2021",
                        description1:"Part-time Freelancer",
                        description:"Provided android application debugging solutions.\nDeveloped android application using Java. Developed web application using various technologies.",
                        skills:["SpringBoot","Android","Java","HMTL","CSS","JavaScript","Bootstrap","PHP","MySQL","Firebase"],
                        icon:"https://www.f-cdn.com/assets/main/en/assets/app-icons/icon-512x512.png"
                    },
                    {
                        name:"National Test House (NTH)",
                        designation:"Technical Support Intern",
                        duration:"May 2019 - Jul 2019",
                        title:"Internship",
                        description:"Techincal Support Intern at National Test House (NTH), Mumbai Area, India. Developed GST Invoice and Proforma Generator.",
                        skills:["HTML","CSS","JavaScript","PHP","Bootstrap"],
                        icon: require('../assets/nth-logo.png')
                    },
                ],
                skills: [
                    {
                        name:"Java",
                        icon:require("../assets/java.png")
                    },
                    {
                        name:"Python",
                        icon:require("../assets/python.png")
                    },
                    {
                        name:"JavaScript",
                        icon:require("../assets/javascript.png")
                    },
                    {
                        name:"SpringBoot",
                        icon:require("../assets/springboot.png")
                    },
                    {
                        name:"Django REST",
                        icon:require("../assets/django.png")
                    },
                    {
                        name:"Android",
                        icon:require("../assets/android.png")
                    },
                    
                    {
                        name:"Node.js",
                        icon:require("../assets/nodejs.png")
                    },
                    {
                        name:"MySQL",
                        icon:require("../assets/mysql.png")
                    },
                    {
                        name:"Postgresql",
                        icon:require("../assets/postgresql.png")
                    },
                    {
                        name:"MongoDB",
                        icon:require("../assets/mongodb.png")
                    },
                    {
                        name:"Postman",
                        icon:require("../assets/postman.png")
                    },
                    {
                        name:"Flask",
                        icon:require("../assets/flask.png")
                    },
                    {
                        name:"React",
                        icon:require("../assets/reactjs.png")
                    },
                    {
                        name:"Angular",
                        icon:require("../assets/angular.png")
                    },
                    {
                        name:"Vue",
                        icon:require("../assets/vuejs.png")
                    },
                    {
                        name:"Git",
                        icon:require("../assets/git.png")
                    },
                    {
                        name:"Heroku",
                        icon:require("../assets/heroku.png")
                    },
                    {
                        name:"AWS",
                        icon:require("../assets/aws.png")
                    },
                    {
                        name:"Firebase",
                        icon:require("../assets/firebase.png")
                    },
                    {
                        name:"Thymeleaf",
                        icon:require("../assets/thymeleaf.png")
                    },
                    {
                        name:"Hibernate",
                        icon:require("../assets/hibernate.svg")
                    },
                    {
                        name:"HTML",
                        icon:require("../assets/html.png")
                    },
                    {
                        name:"CSS",
                        icon:require("../assets/css.png")
                    },
                    {
                        name:"Bootstrap",
                        icon:require("../assets/bootstrap.png")
                    },
                ],
                contributions:[
                    {
                        name:"Added implementation for subtractScalar",
                        pr_no:"PR#3081 (added subtractScalar)",
                        description:"",
                        site_url:"https://mathjs.org/docs/reference/functions/subtract.html",
                        github_url:"https://github.com/josdejong/mathjs",
                        icon:require("../assets/mathjs.png")
                    },
                    {
                        name:"Fixed matrix issue in correlation function",
                        pr_no:"PR#3030 (fixed matrix issue in correlation function + error handling)",
                        description:"",
                        site_url:"https://mathjs.org/docs/reference/functions/corr.html",
                        github_url:"https://github.com/josdejong/mathjs",
                        icon:require("../assets/mathjs.png")
                    },
                    {
                        name:"Added implementation for correlation function",
                        pr_no:"PR#3015 (added correlation function to statistics)",
                        description:"",
                        site_url:"https://mathjs.org/docs/reference/functions/corr.html",
                        github_url:"https://github.com/josdejong/mathjs",
                        icon:require("../assets/mathjs.png")
                    },
                    
                ],
                achievements:[
                    {
                        name:"1st INTERNATIONAL CONFERENCE ON AOTA - 2023",
                        duration:"Jan 2023",
                        description:"Presented Technical Paper and stood runner up under technical track 'Intelligent Optimization' at 1ST INTERNATIONAL CONFERENCE ON ADVANCED OPTIMIZATION TECHNIQUES AND APPLICATIONS (AOTA - 2023) for the paper entitled 'Real-Time Attendance System using Machine Learning Algorithms & Bluetooth'",
                        rank:"Runner Up",
                        icon:"https://cdn-icons-png.flaticon.com/512/3135/3135728.png"
                    },
                    {
                        name:"Smart India Hackathon, 2022",
                        duration:"June 2022",
                        description:"Smart India Hackathon is a nationwide initiative to provide students with a platform to solve some of the pressing problems we face in our daily lives, and thus inculcate a culture of product innovation and a mindset of problem-solving.",
                        rank:"Finalist",
                        icon:"https://cdn-icons-png.flaticon.com/512/3135/3135728.png"
                    },
                    {
                        name:"AISSMS Technical Paper Presentation Competition, 2020",
                        duration:"Feb 2021",
                        description:"Won Technical Paper Presentation competition held at AISSMS for topic Smart Self Checkout System",
                        rank:"Winner",
                        icon:"https://cdn-icons-png.flaticon.com/512/3135/3135728.png"
                    }
                ],
                organizations:[
                    {
                        name:"PICT CSI STUDENT BRANCH (PCSB)",
                        duration:"Oct 2021 - June 2023",
                        designation:"Android Developer",
                        description:"Learning and Contributing as an Native Android Developer at PICT CSI STUDENT BRANCH (PCSB)",
                        icon:require("../assets/pictcsi.png")
                    }
                ]

            }
        },
        mounted(){
            AOS.init({
                duration: 1200,
                easing: 'ease', 
                once: false, 
            });
            $.fn.isInViewport = function() {
                var elementTop = $(this).offset().top;
                var elementBottom = elementTop + $(this).outerHeight();

                var viewportTop = $(window).scrollTop();
                var viewportBottom = viewportTop + $(window).height();

                return elementBottom > viewportTop && elementTop < viewportBottom;
            };

            $(window).on('resize scroll', function() {
                $('.resume-class').each(function() {
                    var activeColor = $(this).attr('id');
                    if ($(this).isInViewport()) {
                        // $('#fixed-' + activeColor).addClass(activeColor + '-active');
                        document.getElementById('fixed-'+activeColor).style.color = "#2F58CD";
                    } else {
                        // $('#fixed-' + activeColor).removeClass(activeColor + '-active');
                        document.getElementById('fixed-'+activeColor).style.color = "black";
                        
                    }
                });
            });
        }
    };
</script>

<style scoped>
    a{
        color: #2F58CD;
    }
    a:hover{
        text-decoration: none;
        font-weight: bold;
    }
    #skills{
        margin-bottom: 20px;
    }
    .skills-container{
        margin-left: 20px;
    }
    .skill-chip{
            background-color: #F9F5EB;
            border-radius: 30px;
            padding: 5px 12px 5px 12px;
            font-size: 0.8rem;
            margin-right: 7px;
            color: #002B5B;
            display: inline-block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 100%;
            transition: transform .5s;
    }

    .skill-chip:hover{
         transform: scale(1.1); 
    }
    .skill-card{
        margin-bottom: 1.1rem;
        margin-left: 0.5rem;
        width: 6rem;
        height: 6rem;
        justify-content: center;
        font-size: 0.9rem;
        border-width: 0px;
        box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
        transition: transform .5s;
    }
    .skill-card:hover {
        transform: scale(1.1); 
    }
    .card-img-top{
        height: 46px;
        width:46px;
        margin-bottom: 5px;
        align-self: center;
    }
    .main-ct {
        position:relative;
       
    }
    .fixed-ct {
        position: sticky;
        position: -webkit-sticky;
        width:100px;
        height:120px;
        margin-bottom: 15%;
        top:10px;
        
    }
   
    .container{
        padding:0px; margin:0px;
    }
    p{
        padding: 0px;
        margin: 0px;
    }
    .edu-duration{
        margin-top: 30px;
        font-weight: light;
    }
    .edu-degree{
        color:#000;
        font-weight: bold;
        font-size: 1.5rem;
     
    }
    .edu-university{
        color:#131313;
        font-weight: bold;
        font-size: 1.1rem;
        margin-top: 5px;
        
    }

    .edu-desc{
        font-size: 1.0rem;
        color:#999999;
    }
    .resume-list{
        font-size: 1.2rem;
        font-weight: bold;
       
       
    }
    .resume-class{
        margin-top:80px ;
        font-size: 2.0rem;
        font-weight: bold;
        color: #2F58CD;
       
    }
    .skill-progress{
        margin-top:20px;
    }
    /* {   min-height: 1px;
        padding-right: 15px;
        padding-left: 15px;
    } */

@media screen and (max-width:768px) {
    .resume-class{

         margin-left: 20px;
    }

    .col-sm-2 {
        width: 40%;
        
    }
    .skill-card{
        margin-bottom: 1rem;
        width: 6rem;
        height: 6rem;
        justify-content: center;
        font-size: 0.9rem;
        border-width: 0px;
        box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
        transition: transform .5s;
    }
    .skill-card:hover {
        transform: scale(1.1); 
    }
    
    .skill-progress{
        margin-top: 40px;
        margin-left: 20px;
        margin-right: 20px;
    }
    table{
        margin: 20px;
    }
}
</style>